import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "quiz-simple-text-question-container"
};
const _hoisted_2 = {
  class: "answer-container"
};
const _hoisted_3 = {
  key: 0,
  class: "answer-label"
};
const _hoisted_4 = {
  class: "answer-body"
};
const _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quiz_question_label = _resolveComponent("quiz-question-label");
  const _component_w_input = _resolveComponent("w-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_quiz_question_label, {
    label: _ctx.questionCustomLabel || _ctx.question.label,
    "label-detail": _ctx.question?.information
  }, null, 8, ["label", "label-detail"]), _createElementVNode("div", _hoisted_2, [_ctx.answerLabel?.length && (!_ctx.isResultMode || _ctx.realValue) ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.answerLabel), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_ctx.isResultMode ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    class: "answer-result",
    innerHTML: _ctx.realValue
  }, null, 8, _hoisted_5)) : (_openBlock(), _createBlock(_component_w_input, {
    key: 1,
    value: _ctx.realValue,
    class: _normalizeClass(['answer-field', _ctx.inputType]),
    type: _ctx.inputType,
    resize: "none",
    onInput: _ctx.onAnswerChange
  }, null, 8, ["value", "class", "type", "onInput"]))])])]);
}